<app-mrp-scrolltop></app-mrp-scrolltop>
<main class="questions-container">
  <article>
    <h1 class="visually-hidden">Frequently Asked Questions About Robert's Rules of Order</h1>
    <h3><b>Common Questions</b></h3>

    <mat-accordion multi="false" class="questions-accordion">

      @for (q of questions; track q) {
        <mat-expansion-panel (click)="logQuestion(q.question)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ q.question}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div [innerHTML]="q.answer"></div>
          </ng-template>
        </mat-expansion-panel>
      }

    </mat-accordion>
  </article>
</main>